import { createAction, props } from "@ngrx/store";
import { RecursivePartial } from "../recursive-partial";
import { CompanyState } from "./company.state";

export const ExtendStateAction = createAction(
    "[Company Action] Extend State",
    props<{ newState: Partial<CompanyState> }>(),
);

export const MergeStateAction = createAction(
    "[Company Action] Merge State",
    props<{ newState: RecursivePartial<CompanyState> }>(),
);

export const InitializeAction = createAction(
    "[Company Action] Initialize Action",
    props<{ companyId: string }>(),
);

export const PurchaseCompanyAction = createAction(
    "[Company Action] Purchase Company Action",
    props<{ companyId: string }>(),
);


